import deepmerge from 'deepmerge';
import BaseConfig from 'base/config';
import BrandConfig from '@/allas/config';

export default deepmerge(BaseConfig, BrandConfig);